import { createContext, useContext } from 'react';
import type { MapEngine } from '../../types/CommonMapTypes';

// How a module (e.g. Asset Overview) shapes the shared CommonMap. Every field is optional, and the default
// is empty, so a module that mounts no provider (Work Orders) keeps today's behaviour.
export interface CommonMapModule {
  // Layers drawn on the map, for this session only; the legend's saved visibility and order are untouched.
  layerIds?: readonly number[];
  // CQL per layer id, applied to that layer's map images.
  filterByLayerId?: ReadonlyMap<number, string>;
  // Fit the camera to these layers' combined extent instead of the map's saved position; re-fits when they change.
  extentLayerIds?: readonly number[];
  // Return true to claim the click: the layer's own attribute popup then stays closed.
  onFeaturePick?: (layerId: number, attributes: Record<string, unknown>) => boolean | void;
  // A click that hit no feature on the drawn layers.
  onPickMiss?: () => void;
  // Features of one layer matching a CQL filter, drawn in `color` (hex) above the data layers.
  highlight?: { layerId: number; cql: string; color: string };
  // Shown when a layer outside `layerIds` finishes processing.
  newLayerNotice?: string;
  // Handed the live engine, and null before it is destroyed.
  onEngineChange?: (engine: MapEngine | null) => void;
}

const NO_MODULE: CommonMapModule = {};

const CommonMapModuleContext = createContext<CommonMapModule>(NO_MODULE);

export const CommonMapModuleProvider = CommonMapModuleContext.Provider;

export const useCommonMapModule = () => useContext(CommonMapModuleContext);
